import {
  Component,
  OnInit,
  AfterViewInit,
  EventEmitter,
  OnChanges,
  Input,
  Output,
} from '@angular/core';
import { forkJoin } from 'rxjs';
import { DashboardService } from './../../../services/dashboard.service';

import * as _ from 'lodash';
import { environment } from './../../../../environments/environment';
import {
  NgbDateStruct,
  NgbModal,
  NgbActiveModal,
} from '@ng-bootstrap/ng-bootstrap';
import { CalendarTaskDetailsComponent } from './../calendar-task-details/calendar-task-details.component';
import { MeetingdetailsComponent } from '../meetingdetails/meetingdetails.component';
import { NotificationComponent } from './../notification/notification.component';
import { MeetingMasterService } from '../../../services/meetingMaster.service';
import { CompanyMasterService } from '../../../services/companymaster.service';
import * as moment from 'moment';
//have to implement taskdetails based on task from compliance or not
import { ActivatedTaskFromComplianceService } from './../../../services/activatedTaskFromCompliance.service';
import { DashboardMyTaskService } from './../../../services/dashboardmytask.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { MeetingLaunchService } from 'src/app/services/meeting-launch.service';

declare var $: any;
declare var jQuery: any;
declare var autosize: any;
declare var Ladda: any;
declare var Chartist: any;
declare var Chart: any;

@Component({
  selector: 'app-calendar-task',
  templateUrl: './calendar-task.component.html',
  styleUrls: ['./calendar-task.component.css'],
})
export class CalendarTaskComponent implements OnInit, AfterViewInit, OnChanges {

  public activeId: any;
  public googleCalendarAPI: string;
  meetingListCache: any;
  private meetingList: any;

  @Input('refreshData') refreshData: any;
  @Input('rowFive') rowFive: any;

  @Output() outputStatus = new EventEmitter();

  public monthNameArray = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  // isMyTaskFetch: any;
  isMeetingFetch: any;
  
  // Color palette for meetings - matching screenshot colors (pinkish-red, light blue, etc.)
  private meetingColorPalette = [
    { bg: '#FFE5E5', border: '#FF6B6B', text: '#000000' }, // Pinkish-red (matching screenshot)
    { bg: '#E3F2FD', border: '#64B5F6', text: '#000000' }, // Light blue (matching screenshot)
    { bg: '#E8F5E9', border: '#81C784', text: '#000000' }, // Light green
    { bg: '#F3E5F5', border: '#BA68C8', text: '#000000' }, // Light purple
    { bg: '#FFF3E0', border: '#FFB74D', text: '#000000' }, // Light orange/peach
    { bg: '#E0F2F1', border: '#4DB6AC', text: '#000000' }, // Teal
    { bg: '#FFF9C4', border: '#FFD54F', text: '#000000' }, // Yellow
    { bg: '#FCE4EC', border: '#F48FB1', text: '#000000' }, // Pink
    { bg: '#E8EAF6', border: '#9FA8DA', text: '#000000' }, // Indigo
    { bg: '#E1F5FE', border: '#4FC3F7', text: '#000000' }, // Light cyan
  ];

  // Cache for meeting name to color mapping
  private meetingColorMap: Map<string, any> = new Map();

  constructor(
    private companyMasterService: CompanyMasterService,
    private meetingMasterService: MeetingMasterService,
    private dashboardService: DashboardService,
    private modalService: NgbModal,
    private alert1: AlertService,
    private meetingLaunchService: MeetingLaunchService,
    private activatedTaskFromComplianceService: ActivatedTaskFromComplianceService,
    private dashboardMyTaskService: DashboardMyTaskService,
    private router: Router
  ) { }

  ngOnInit() { }

  /**
   * Generate a consistent color for a meeting name
   * Same meeting names will always get the same color
   */
  private getMeetingColor(meetingName: string): any {
    if (!meetingName) {
      return this.meetingColorPalette[0];
    }

    // Check cache first
    if (this.meetingColorMap.has(meetingName)) {
      return this.meetingColorMap.get(meetingName);
    }

    // Generate hash from meeting name
    let hash = 0;
    for (let i = 0; i < meetingName.length; i++) {
      hash = meetingName.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Get color from palette based on hash
    const colorIndex = Math.abs(hash) % this.meetingColorPalette.length;
    const color = this.meetingColorPalette[colorIndex];

    // Cache the color for this meeting name
    this.meetingColorMap.set(meetingName, color);

    return color;
  }

  /**
   * Format time from date string for display
   */
  private formatTime(dateStr: string): string {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return '';
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? 'pm' : 'am';
      const displayHours = hours % 12 || 12;
      const displayMinutes = minutes < 10 ? `0${minutes}` : minutes;
      return `${displayHours}:${displayMinutes}${ampm}`;
    } catch (e) {
      return '';
    }
  }

  /**
   * Calculate end time from start time (default 1 hour duration)
   */
  private calculateEndTime(startTimeStr: string, durationHours: number = 1): string {
    if (!startTimeStr) return '';
    try {
      const startDate = new Date(startTimeStr);
      if (isNaN(startDate.getTime())) return '';
      const endDate = new Date(startDate.getTime() + durationHours * 60 * 60 * 1000);
      return this.formatTime(endDate.toISOString());
    } catch (e) {
      return '';
    }
  }

  // Track current view for custom Y/M/D toggle
  activeView: 'year' | 'month' | 'day' = 'month';

  changeCalendarView(view: 'year' | 'month' | 'day') {
    this.activeView = view;

    // Map our custom views to FullCalendar views
    let fcView = 'month';
    if (view === 'day') {
      fcView = 'agendaDay';
    } else if (view === 'year') {
      // Fallback: use month view for now, or listYear if configured
      fcView = 'month';
    }

    try {
      $('#meeting').fullCalendar('changeView', fcView);
    } catch (e) {
      // Fail silently if FullCalendar is not initialized yet
      // console.warn('Unable to change calendar view', e);
    }
  }

  ngAfterViewInit() {
    const self = this;
    // this.googleCalendarAPI = environment.clientUrl + 'calendar/google/auth'
    var userInfo = JSON.parse(localStorage.getItem('user'));
    // this.activeId = "myTaskTab"
    // let calenderDomId = "myTask"
    // const taskList = [];
    // this.isMyTaskFetch = localStorage.getItem("isMyTaskFetch");
    // if(this.isMyTaskFetch != "false"){
    //   setTimeout(function () {
    //     self.fullCalender(calenderDomId, taskList)
    //   }, 100)
    // }
    this.activeId = 'meetingTab';
    let calenderDomId = 'meeting';
    const meetingList = [];
    this.isMeetingFetch = localStorage.getItem('isMeetingFetch');
    if (this.isMeetingFetch != 'false') {
      setTimeout(function () {
        self.fullCalender(calenderDomId, meetingList);
      }, 100);
    }
  }

  ngOnChanges() {
    ////console.log('calendar task object changes', this.refreshData);
    this.ngAfterViewInit();
  }

  clearModalsAndBackdrop(): void {
    // Force hide all open modals
    $('.modal').modal('hide');

    // Remove any lingering modal backdrops
    $('.modal-backdrop').remove();

    // Remove 'modal-open' class from body if still present
    $('body').removeClass('modal-open').css('padding-right', '');
  }

  fullCalender(calendarDOMID, taskList) {
    const self = this;
    $('#' + calendarDOMID).fullCalendar({
      //aspectRatio: 2,
      height: 475,
      header: {
        left: 'prev,title,next',
        center: '',
        // right: 'month, agendaWeek, agendaDay'
        right: '',
      },
      buttonIcons: {
        prev: 'none fa fa-chevron-left',
        next: 'none fa fa-chevron-right',
        prevYear: 'none fa fa-arrow-left',
        nextYear: 'none fa fa-arrow-right',
      },
      // theme: true,
      // themeSystem:'bootstrap3',
      displayEventTime: true, // Enable time display
      timeFormat: 'h:mm a', // Format: 10:00 am
      editable: false,
      eventLimit: false, // allow "more" link when too many events
      eventStartEditable: false,
      viewRender: function (view, element) {
        // Inject Y M D buttons into the toolbar on the right side
        const calendarId = '#' + calendarDOMID;
        const toolbar = $(calendarId).closest('.meetingtab').find('.fc-toolbar');
        const rightElement = toolbar.find('.fc-right');
        const leftElement = toolbar.find('.fc-left');
        
        // Set month name (December 2025) color to blue
        leftElement.find('h2').css({
          'color': '#1e458b'
        });
        toolbar.find('h2').css({
          'color': '#1e458b'
        });
        // Also target any h2 in the toolbar
        $(calendarId).closest('.meetingtab').find('.fc-toolbar h2').css({
          'color': '#1e458b'
        });
        
        // Set navigation arrows (prev/next buttons) color to blue
        leftElement.find('.fc-prev-button, .fc-next-button, button.fc-prev-button, button.fc-next-button').css({
          'color': '#1e458b'
        });
        toolbar.find('.fc-prev-button, .fc-next-button, button.fc-prev-button, button.fc-next-button').css({
          'color': '#1e458b'
        });
        $(calendarId).closest('.meetingtab').find('.fc-toolbar .fc-prev-button, .fc-toolbar .fc-next-button').css({
          'color': '#1e458b'
        });
        
        // Remove existing Y M D buttons if they exist
        rightElement.find('.calendar-view-toggle-inline').remove();
        
        // Create Y M D buttons
        const yearActive = self.activeView === 'year' ? 'active' : '';
        const monthActive = self.activeView === 'month' ? 'active' : '';
        const dayActive = self.activeView === 'day' ? 'active' : '';
        
        const viewToggleHtml = `
          <div class="calendar-view-toggle-inline">
            <button type="button" class="view-toggle-btn ${yearActive}" data-view="year">
              Y
            </button>
            <button type="button" class="view-toggle-btn ${monthActive}" data-view="month">
              M
            </button>
            <button type="button" class="view-toggle-btn ${dayActive}" data-view="day">
              D
            </button>
          </div>
        `;
        
        // Append Y M D buttons to the right element
        rightElement.append(viewToggleHtml);
        
        // Apply circular styles directly to ensure they're applied
        rightElement.find('.view-toggle-btn').css({
          'border': 'none',
          'background': 'transparent',
          'color': '#1e458b', // Blue color
          'border-radius': '50%',
          'padding': '0',
          'font-size': '13px',
          'font-weight': '500',
          'cursor': 'pointer',
          'width': '32px',
          'height': '32px',
          'min-width': '32px',
          'min-height': '32px',
          'max-width': '32px',
          'max-height': '32px',
          'text-align': 'center',
          'outline': 'none',
          'transition': 'all 0.2s ease',
          'line-height': '32px',
          'display': 'inline-flex',
          'align-items': 'center',
          'justify-content': 'center',
          'box-sizing': 'border-box'
        });
        
        // Add click handlers
        rightElement.find('.view-toggle-btn').off('click').on('click', function() {
          const viewType = $(this).data('view');
          self.changeCalendarView(viewType);
        });
        
        // Update active state
        rightElement.find('.view-toggle-btn').removeClass('active');
        rightElement.find(`.view-toggle-btn[data-view="${self.activeView}"]`).addClass('active');
        
        // Ensure hover and active states maintain circular shape
        rightElement.find('.view-toggle-btn').on('mouseenter', function() {
          if (!$(this).hasClass('active')) {
            $(this).css({
              'background': 'rgba(30, 69, 139, 0.1)', // Light blue background on hover
              'color': '#1e458b', // Blue color
              'border-radius': '50%'
            });
          }
        }).on('mouseleave', function() {
          if (!$(this).hasClass('active')) {
            $(this).css({
              'background': 'transparent',
              'color': '#1e458b', // Blue color
              'border-radius': '50%'
            });
          }
        });
        
        // Active state styling
        rightElement.find('.view-toggle-btn.active').css({
          'background': '#1e458b', // Blue background for active
          'color': '#ffffff', // White text on active
          'font-weight': '600',
          'border-radius': '50%'
        });
        
        // Force layout fix: ensure everything stays on one line
        setTimeout(function() {
          const leftDiv = toolbar.find('.fc-left > div');
          if (leftDiv.length) {
            leftDiv.css({
              'display': 'flex',
              'align-items': 'center',
              'gap': '8px',
              'flex-wrap': 'nowrap',
              'white-space': 'nowrap'
            });
          }
          toolbar.css({
            'flex-wrap': 'nowrap',
            'overflow': 'visible'
          });
          toolbar.find('.fc-left').css({
            'flex-wrap': 'nowrap',
            'white-space': 'nowrap'
          });
          toolbar.find('.fc-right').css({
            'flex-wrap': 'nowrap'
          });
        }, 10);
      },
      // defaultDate: '2017-05-12',
      events: function (start, end, timezone, callback) {
        // Use the start/end provided by FullCalendar so month/day views both work correctly
        const firstDate = start && (start.toDate ? start.toDate() : new Date(start));
        const lastDate = end && (end.toDate ? end.toDate() : new Date(end));
        const userId = JSON.parse(localStorage.getItem('user'))._id;
        const uniqueUserId = JSON.parse(
          localStorage.getItem('user')
        ).UniqueUserId;
        let rangeOfDate = {
          userId: userId,
          firstDate: firstDate,
          lastDate: lastDate,
        };
        let userInfo = JSON.parse(localStorage.getItem('user'));
        let assignedToId = userInfo._id;
        let companyId = userInfo.CompanyId;
        const isMyTask = localStorage.getItem("isMyTaskFetch");
        //console.log("isMyTask", isMyTask)
        self.dashboardMyTaskService.getUserIdbyUniqueUserId(uniqueUserId, true).then(responseForCompanyAndUserId => {
          if (!responseForCompanyAndUserId.status) {
            if (calendarDOMID == 'meeting') {
              //console.log('it is inside meeting')
              let meetingPromise = [];
              for (var meetingIndex = 0; meetingIndex < responseForCompanyAndUserId.listOfId.length; meetingIndex++) {
                meetingPromise.push(self.meetingMasterService.getMeetingList(responseForCompanyAndUserId.listOfId[meetingIndex].CompanyId))
              }
              // to get GEM URL First and then calling other function
              var gemURL = '';
              self.companyMasterService
                .getGEMUrl()
                .then((responseCompany) => {
                  //console.log("response GEM URL", responseCompany);
                  if (responseCompany.status == 0) {
                    var companyDetails = responseCompany.companyData;
                    //console.log("response GEM URL companyDetails", companyDetails);
                    if (_.size(companyDetails)) {
                      gemURL = companyDetails[0].GEMAccessURL
                        ? companyDetails[0].GEMAccessURL
                        : '';
                      //console.log("gemURL", gemURL);
                      if (_.size(gemURL)) {
                        meetingPromise.push(
                          self.meetingMasterService.getRegularMeetingList(gemURL, true) // 👈 true disables loader
                        );
                      }
                    }
                  }
                });

              forkJoin(meetingPromise).subscribe((responseforMeetings) => {
                let errorObject = _.find(
                  responseforMeetings,
                  function (element) {
                    return _.get(element, 'status') == 1;
                  }
                );
                if (_.isUndefined(errorObject)) {
                  let userSpecificMeetingList: any = [];
                  let tempArray = [];
                  self.meetingList = _.map(
                    responseforMeetings,
                    function (element) {
                      if (!_.isUndefined(_.get(element, 'MeetingList'))) {

                        return _.concat(
                          tempArray,
                          _.get(element, 'MeetingList')
                        );
                      } else {

                        return _.concat(tempArray, element);
                      }

                    }
                  );

                  self.meetingList = _.flattenDeep(self.meetingList);

                  if (_.size(self.meetingList)) {
                    userSpecificMeetingList = _.filter(
                      self.meetingList,
                      function (meetingObject) {
                        if (_.size(_.get(meetingObject, 'Directors'))) {
                          var directorArray = _.find(
                            _.get(meetingObject, 'Directors'),
                            function (directorObject) {
                              if (
                                _.get(directorObject, 'UserGovevaId') !=
                                undefined
                              ) {
                                let assignedUser = _.find(
                                  responseForCompanyAndUserId.listOfId,
                                  function (element) {
                                    return (
                                      element._id ==
                                      _.get(directorObject, 'UserGovevaId')
                                    );
                                  }
                                );
                                if (!_.isUndefined(assignedUser)) {
                                  // if (_.get(directorObject, 'UserGovevaId') == assignedToId) {
                                  return directorObject;
                                }
                              }
                            }
                          );

                          if (_.size(directorArray)) {
                            return meetingObject;
                          }
                        }

                        if (_.size(_.get(meetingObject, 'Members'))) {
                          var memberArray = _.find(
                            _.get(meetingObject, 'Members'),
                            function (memberObject) {
                              let assignedUser = _.find(
                                responseForCompanyAndUserId.listOfId,
                                function (element) {
                                  return (
                                    element._id ==
                                    _.get(memberObject, 'UserGovevaId')
                                  );
                                }
                              );
                              if (!_.isUndefined(assignedUser)) {
                                // if (_.get(memberObject, 'UserGovevaId') == assignedToId) {
                                return memberObject;
                              }
                            }
                          );

                          if (_.size(memberArray)) {
                            return meetingObject;
                          }
                        }

                        if (_.size(_.get(meetingObject, 'Invitees'))) {
                          var inviteesArray = _.find(
                            _.get(meetingObject, 'Invitees'),
                            function (inviteesObject) {
                              let assignedUser = _.find(
                                responseForCompanyAndUserId.listOfId,
                                function (element) {
                                  return (
                                    element._id ==
                                    _.get(inviteesObject, 'UserGovevaId')
                                  );
                                }
                              );
                              if (!_.isUndefined(assignedUser)) {
                                // if (_.get(inviteesObject, 'UserGovevaId') == assignedToId) {
                                return inviteesObject;
                              }
                            }
                          );

                          if (_.size(inviteesArray)) {
                            return meetingObject;
                          }
                        }

                        if (_.size(_.get(meetingObject, 'meetingType'))) {
                          var meetingType = _.get(
                            meetingObject,
                            'meetingType'
                          );
                          if (!_.isUndefined(meetingType)) {
                            // //console.log("regular meeting added",meetingType, 'REGULAR_MEETING');
                            if (meetingType == 'REGULAR_MEETING') {
                              return meetingObject;
                            }
                          }
                        }
                      }
                    );
                  }
                  var meetingListMain: any = [];
                  //console.log('userSpecificMeetingList for meeting', userSpecificMeetingList)
                  self.meetingListCache = userSpecificMeetingList;
                  const meetingList = userSpecificMeetingList.map((o) => {
                    ///testing for meeting alert by nikhil
                    // console.log("meeting : ", o.MeetingDate);
                    const meetingDateStr = o.MeetingDate; // From API
                    const meetingDate = new Date(meetingDateStr);
                    const now = new Date();

                    // Check if meeting is today
                    const isSameDay =
                      meetingDate.getFullYear() === now.getFullYear() &&
                      meetingDate.getMonth() === now.getMonth() &&
                      meetingDate.getDate() === now.getDate();

                    // Check if meeting is within next 5 minutes
                    const timeDifference = meetingDate.getTime() - now.getTime();
                    const isWithinFiveMinutes = timeDifference > 0 && timeDifference <= 5 * 60 * 1000;
                      //isko uncomment karna
                    if (isSameDay && isWithinFiveMinutes) {
                      // ✅ Your condition here
                      if (self.alert1) {
                        self.alert1.notify("" +
                          o.MeetingTypeName + "Meeting starts in next 5 minutes. " + o.MeetingDate,
                          () => {
                            self.meetingLaunchService.launchMeeting(o,true);
                            self.clearModalsAndBackdrop(); // ✅ Run only after OK is clicked
                          },
                        () => {
                          self.clearModalsAndBackdrop(); 
                        });
                        }
                else {
                  console.warn('⚠️ alert1 is undefined at time of meeting alert call');
                }
              }
                    ///testing for meeting alert by nikhil
                    const meetingTitle = o.MeetType == 'Meeting' ? o.MeetingTypeName : `CR-${o.MeetingTypeName}`;
                    const meetingColor = self.getMeetingColor(meetingTitle);
                    const meetingStartTime = o.meetingType ? o.meetingDateInDate : o.MeetingDate;
                    
                    // Calculate end time - use MeetingEndDate if available, otherwise add 1 hour to start
                    let meetingEndTime;
                    if (o.meetingType && o.meetingEndDate) {
                      meetingEndTime = o.meetingEndDate;
                    } else if (o.MeetingEndDate) {
                      meetingEndTime = o.MeetingEndDate;
                    } else {
                      // Default to 1 hour after start time
                      try {
                        const startDate = new Date(meetingStartTime);
                        meetingEndTime = new Date(startDate.getTime() + 60 * 60 * 1000).toISOString();
                      } catch (e) {
                        meetingEndTime = meetingStartTime;
                      }
                    }
                    
                    // Format time for display
                    const startTimeStr = self.formatTime(meetingStartTime);
                    const endTimeStr = self.formatTime(meetingEndTime);
                    const timeRange = startTimeStr && endTimeStr ? `${startTimeStr} - ${endTimeStr}` : startTimeStr || '';
                    
                    return {
                _id: o.meetingType ? o.meetingId : o._id,
                title: meetingTitle,
                start: meetingStartTime,
                end: meetingEndTime || meetingStartTime,
                className: 'fc-event-modern',
                activatedTaskFromCompliance: 'meeting',
                color: meetingColor.bg,
                textColor: meetingColor.text,
                borderColor: meetingColor.border,
                meetingName: meetingTitle,
                timeRange: timeRange,
                originalMeeting: o, // Store original meeting object for details
              };
            });
        //console.log("meetingList----calendar", meetingList);
        callback(meetingList);
      } else {
        // If errorObject is defined, call callback with empty array
        callback([]);
      }
            },
            (error) => {
              console.error('Error fetching meetings:', error);
              callback([]);
            }
          );
          } else if (calendarDOMID == 'myTask' && isMyTask != 'false') {
  let myTaskPromise = [];
  var taskListMain: any = [];
  for (
    var userIndex = 0;
    userIndex < responseForCompanyAndUserId.listOfId.length;
    userIndex++
  ) {
    rangeOfDate.userId =
      responseForCompanyAndUserId.listOfId[userIndex]._id;
    myTaskPromise.push(
      self.dashboardService.getTaskListbydateRange(rangeOfDate)
    );
  }

  forkJoin(myTaskPromise).subscribe(
    (responseFormyTaskForDifferentUserId) => {
      //console.log('responseFormyTaskForDifferentUserId', responseFormyTaskForDifferentUserId)
      let errorObject = _.find(
        responseFormyTaskForDifferentUserId,
        function (element) {
          return !_.isUndefined(_.get(element, 'taskList'));
        }
      );
      //console.log('in my task', _.isNil(errorObject))
      if (_.isNil(errorObject)) {
        let taskArray = [];
        let tempList = [];
        taskArray = _.map(
          responseFormyTaskForDifferentUserId,
          function (element) {
            return _.concat(tempList, _.get(element, 'result'));
          }
        );
        taskArray = _.flatten(taskArray);
        //console.log('taskArray======>', taskArray)
        let taskList = taskArray.map(function (o) {
          return {
            _id: o._id,
            title: o.TaskName,
            start: moment(o.StartDate),
            end: moment(o.EndDate).add(1, 'days'),
            className: 'fc-event-default',
            activatedTaskFromCompliance: false,
          };
        });
        //console.log("taskList", taskList);
        // callback(taskList)
        taskListMain = taskListMain.concat(taskList);
        //console.log("tasklistMain", taskListMain);
      }
      // If companyId is empty, call callback here since getMyActivatedTaskList won't be called
      if (companyId == '') {
        callback(taskListMain);
      }
    },
    (error) => {
      console.error('Error fetching my tasks:', error);
      callback([]);
    }
  );

  // self.dashboardService.getTaskListbydateRange(rangeOfDate).then(response => {
  //   //console.log("mytask", response);
  // if (!response.status) {
  //   const taskList = response.result.map(function (o) {
  //     return {
  //       _id: o._id,
  //       title: o.TaskName,
  //       start: moment(o.StartDate),
  //       end: moment(o.EndDate).add(1, 'days'),
  //       className: 'fc-event-default',
  //       activatedTaskFromCompliance: false
  //     }
  //   })
  //   //console.log("taskList", taskList);
  //   // callback(taskList)
  //   taskListMain = taskListMain.concat(taskList);
  //   //console.log("tasklistMain", taskListMain);
  // }
  if (companyId != '') {
    // self.activatedTaskFromComplianceService.getActivatedTaskWithAdditionalJsonData(companyId).then(result => {

    self.activatedTaskFromComplianceService
      .getMyActivatedTaskList(companyId, assignedToId)
      .then((result) => {
        //console.log("testservice result", result);

        if (result != undefined) {
          //added on 5Apr
          //removed such task which has start date and end date null or date key not available

          result = result.filter(
            (g) =>
              g.StartDate != null &&
              g.StartDate != undefined &&
              g.EndDate != undefined &&
              g.EndDate != null
          );
          // g.StartDate!= null || g.StartDate!= undefined || g.EndDate!= null ||

          const activeTaskList = result.map(function (o) {
            return {
              _id: o._id,
              title: o.TaskName,
              start: moment(o.StartDate), //"2018-02-27T13:47:10.957Z",//o.TriggerStartDate,
              end: moment(o.EndDate).add(1, 'days'),
              className: 'bday_block',
              activatedTaskFromCompliance: true, //o.ActivatedTaskFromCompliance,
            };
          });

          taskListMain = taskListMain.concat(activeTaskList);
        }
        callback(taskListMain);
      });
  }
  // })
} else {
  var teamTaskListMain: any = [];

  self.dashboardService
    .getTeamTaskByUserId(rangeOfDate)
    .then((response) => {
      //console.log("mytask by userID", response);
      if (!response.status) {
        const taskList = response.result.map(function (o) {
          return {
            _id: o._id,
            title: o.TaskName,
            start: moment(o.StartDate),
            end: moment(o.EndDate).add(1, 'days'),
            className: 'fc-event-default',
            activatedTaskFromCompliance: false,
          };
        });

        teamTaskListMain = teamTaskListMain.concat(taskList);
        callback(teamTaskListMain);
      }
    });

  if (companyId != '') {
    //api in goveva calls the internally pss api by sending user ids and date range.

    let rangeOfDateForCompliance = {
      companyId: companyId,
      userId: userId,
      firstDate: firstDate,
      lastDate: lastDate,
    };

    // TODO: Data manupulate here !!!!

    self.activatedTaskFromComplianceService
      .getComplianceTeamTaskList(rangeOfDateForCompliance)
      .then((result) => {
        //console.log("testservice result", result);

        if (result != undefined) {
          //removed such task which has start date and end date null or date key not available

          result = result.filter(
            (g) =>
              g.StartDate != null &&
              g.StartDate != undefined &&
              g.EndDate != undefined &&
              g.EndDate != null
          );

          const taskList = result.map(function (o) {
            return {
              _id: o._id,
              title: o.TaskName,
              start: moment(o.StartDate),
              end: moment(o.EndDate).add(1, 'days'),
              className: 'bday_block',
              activatedTaskFromCompliance: true,
            };
          });
          teamTaskListMain = teamTaskListMain.concat(taskList);
          callback(teamTaskListMain);
        }
      });
  }
}
          } else {
            // If responseForCompanyAndUserId has status error, call callback with empty array
            callback([]);
          }
        }).catch((error) => {
          // Error in getUserIdbyUniqueUserId - call callback with empty array
          console.error('Error getting user companies:', error);
          callback([]);
        });
      },
    eventClick: function(calEvent, jsEvent, view) {
      // click of the event in the calender.
      // add modal here to show task details.
      // get information for the task
      // ////console.log('calEvent', calEvent, jsEvent)

      //console.log("calEvent, jsEvent, view", calEvent, jsEvent, view);

      if (calEvent.activatedTaskFromCompliance == 'meeting') {
        const meetingDetails = _.find(
          self.meetingListCache,
          function (meeting) {
            // as regular meeting doesnt have _id  we have to map id accordingly
            var meetingId = meeting.meetingType
              ? meeting.meetingId
              : meeting._id;
            if (meetingId == calEvent._id) {
              return meeting;
            }
          }
        );

        //console.log("meetingDetails", meetingDetails);

        if (_.size(meetingDetails)) {
          const modalRef = self.modalService.open(MeetingdetailsComponent, {
            windowClass: 'modal-xlC',
          });
          modalRef.componentInstance.meetingObject = meetingDetails;
          modalRef.result
            .then(
              (response) => {
                console.log('response from calender view ---->', response);
                var joinInPerson = localStorage.getItem('joinInPerson');
                if (joinInPerson != 'yes') {
                  self.router.navigate(['webex', response]);
                } else {
                  var meetingIdToSend = localStorage.getItem('meetingId');
                  self.router.navigate(['/attending-inperson', response]);
                }
              },
              (error) => {
                //console.log("modalthenerror", error)
              }
            )
            .catch((error) => {
              //console.log("Catch Error", error)
            });
        } else {
          const modalRef = self.modalService.open(MeetingdetailsComponent, {
            size: 'lg',
          });
          modalRef.componentInstance.meetingObject = [];
          modalRef.result
            .then(
              (response) => {
                console.log('response', response);
              },
              (error) => {
                //console.log("modalthenerror", error)
              }
            )
            .catch((error) => {
              //console.log("Catch Error", error)
            });
        }
      } else {
        const modalRef = self.modalService.open(
          CalendarTaskDetailsComponent,
          { size: 'lg' }
        );
        modalRef.componentInstance.taskId = {
          _id: calEvent._id,
          calendarId: calendarDOMID,
          activatedTaskFromCompliance: calEvent.activatedTaskFromCompliance,
        };
        modalRef.result.then(
          (response) => {
            // update the class name here if we are using status.
            if (!response.status) {
              self.outputStatus.emit(response);
              self.ngAfterViewInit();
              const notificationModalRef = self.modalService.open(
                NotificationComponent
              );
              notificationModalRef.componentInstance.notify = {
                status: 'Success',
                message: 'Task status is updated successfully',
              };
            } else {
              const notificationModalRef = self.modalService.open(
                NotificationComponent
              );
              notificationModalRef.componentInstance.notify = {
                status: 'Failure',
                message: 'OOPS! Something went wrong.',
              };
            }
          },
          (reason) => { }
        );
      }
    },
    eventRender: function (event, element) {
      // Apply clean styling matching screenshot
      if (event.color) {
        element.css({
          'background-color': event.color,
          'border': 'none',
          'border-radius': '4px',
          'color': '#000000',
          'padding': '6px 8px',
          'margin': '1px 0',
          'font-size': '13px',
          'font-weight': '500',
          'cursor': 'pointer',
          'box-shadow': 'none',
          'transition': 'opacity 0.2s ease',
          'line-height': '1.3',
        });

        // Ensure all text inside is black
        element.find('*').css({
          'color': '#000000 !important',
        });

        // Add subtle hover effect
        element.on('mouseenter', function() {
          $(this).css({
            'opacity': '0.9',
          });
        });

        element.on('mouseleave', function() {
          $(this).css({
            'opacity': '1',
          });
        });

        // Update event content to show title and time range
        const content = element.find('.fc-content');
        if (content.length && event.timeRange) {
          const titleElement = content.find('.fc-title');
          const timeElement = content.find('.fc-time');
          
          if (titleElement.length) {
            // Clean format matching screenshot
            titleElement.html(`<div style="font-weight: 500; line-height: 1.3; margin-bottom: 2px; color: #000000; font-size: 13px;">${event.title}</div><div style="font-size: 11px; color: #333333; font-weight: 400;">${event.timeRange}</div>`);
          }
          
          // Hide default time display if we're showing custom time range
          if (timeElement.length) {
            timeElement.hide();
          }
        } else if (content.length && event.timeRange) {
          // If structure is different, try to update the whole content
          content.html(`<div class="fc-title" style="font-weight: 500; line-height: 1.3; margin-bottom: 2px; color: #000000; font-size: 13px;">${event.title}</div><div style="font-size: 11px; color: #333333; font-weight: 400;">${event.timeRange}</div>`);
        } else if (content.length) {
          // Even without time range, ensure text is black
          const titleElement = content.find('.fc-title');
          if (titleElement.length) {
            titleElement.css({
              'color': '#000000',
              'font-size': '13px',
              'font-weight': '500',
            });
          }
        }
      } else {
        // Fallback styling
        element.css({
          cursor: 'pointer',
          'border-radius': '4px',
          'padding': '6px 8px',
          'margin': '1px 0',
          'color': '#000000',
          'font-size': '13px',
          'box-shadow': 'none',
        });
      }
    }
  });
  }

  tabSelected(data) {
  // ////console.log(data, data.nextId == "teamTaskTab")
  if (this.isMeetingFetch != 'false') {
    const self = this;
    const userInfo = JSON.parse(localStorage.getItem('user'));
    if (data == 'meetingTab') {
      const calendarId = 'meeting';
      const meetingList = [];
      setTimeout(function () {
        self.fullCalender(calendarId, meetingList);
      }, 100);
    } else if (data == 'teamTaskTab') {
      const calendarId = 'teamTask';
      const taskList = [];

      setTimeout(function () {
        self.fullCalender(calendarId, taskList);
      }, 100);
    } else {
      ////console.log('inside my task')
      const calendarId = 'myTask';
      const taskList = [];
      setTimeout(function () {
        self.fullCalender(calendarId, taskList);
      }, 100);
    }
  }
}
}
